module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-ster-c7b4c726d2237142ac2e689873f3111d.png";